import React from "react";

function SkillCategoryCard({
  title,
  icon,
  skills = [],
  shadowColor = "#ccd5ae",
  hoverShadowColor = "#d4a373",
}) {
  return (
    <div
      style={{
        "--card-shadow": shadowColor,
        "--card-hover-shadow": hoverShadowColor,
      }}
      className="border-2 border-slate-900 bg-white rounded-2xl overflow-hidden shadow-[6px_6px_0px_0px_var(--card-shadow)] hover:shadow-[10px_10px_0px_0px_var(--card-hover-shadow)] transition-all duration-300 flex flex-col group"
    >
      {/* Header Kartu: Menyerupai Top Bar Window / Folder */}
      <div className="border-b-2 border-slate-900 bg-gsf-sand/30 px-4 py-3 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <span className="text-sm">{icon}</span>
          <h3 className="text-sm font-black text-slate-900 uppercase tracking-wider">
            {title}
          </h3>
        </div>
        {/* Dekorasi Tiga Titik ala Window Terminal */}
        <div className="flex gap-1 select-none">
          <span className="w-2 h-2 rounded-full bg-slate-300 border border-slate-400"></span>
          <span className="w-2 h-2 rounded-full bg-slate-300 border border-slate-400"></span>
          <span className="w-2 h-2 rounded-full bg-slate-300 border border-slate-400"></span>
        </div>
      </div>

      {/* Isi Konten: Grid Parameter / Tech Stack */}
      <div className="p-5 flex-1 bg-white relative overflow-hidden">
        {/* Background Mesh Grid Halus Khas Engineering */}
        <div className="absolute inset-0 bg-grid-pattern opacity-10 pointer-events-none"></div>

        <div className="flex flex-wrap gap-2 relative z-10">
          {skills.map((skill, index) => (
            <div
              key={index}
              className="border-2 border-slate-900 bg-white px-3 py-1.5 rounded-xl font-mono text-xs font-bold text-slate-800 flex items-center gap-1.5 shadow-[2px_2px_0px_0px_#ccd5ae] hover:shadow-[2px_2px_0px_0px_#d4a373] hover:-translate-y-0.5 transition-all cursor-default"
            >
              {/* Indikator Prompt Kode Mini */}
              <span className="text-gsf-bronze font-black select-none">
                &gt;_
              </span>
              {skill}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default SkillCategoryCard;
